import { ComponentChild, Component, h } from 'preact'
import LazyLoader from '../lazy-loading/LazyLoader'

interface Props {
  idx: number,
  title: string,
  customClass?: string,
  style?: Object,
  metadata?: ComponentChild,
  navigation?: {
    url: string,
    target?: '_blank'
  },
  imageSrc?: string
}

interface State {}

class Card extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {}
  }

  render ({ customClass, style, navigation, title, imageSrc, metadata, idx }: Props, state: State) {
    return (
      <article
        class={`card ${customClass} card-widget-wrapper`}
        style={style}>
        {
          navigation ? (
            <a href={navigation.url} class='card_url' target={navigation?.target}>
              {imageSrc
                ? (
                  <figure>
                    <LazyLoader
                      type='background'
                      src={imageSrc}
                      classNames='card_image'
                      alt={`Community category image ${idx + 1}`}
                    />
                  </figure>
                )
                : null }
              <div className='card_info'>
                <header><h3 className='card_info__title card-widget-title'>{ title }</h3></header>
                {
                  metadata ? (
                    <p className='text--meta card-info__metadata'>
                      { metadata }
                    </p>
                  ) : null
                }
              </div>
            </a>
          ) : null
        }
      </article>
    )
  }
}

export default Card
